/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Scuola } from './scuola';


export interface ServizioMensaStudenteDiscoveryDTO { 
    id?: string;
    nome?: string;
    cognome?: string;
    scuola?: Scuola;
    is_sospeso?: boolean;
    is_esente?: boolean;
}

